/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tl_Clear_DatesInputs */

const en_tl_clear_dates = /** @type {(inputs: Tl_Clear_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear dates`)
};

const de_tl_clear_dates = /** @type {(inputs: Tl_Clear_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termine entfernen`)
};

/**
* | output |
* | --- |
* | "Clear dates" |
*
* @param {Tl_Clear_DatesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tl_clear_dates = /** @type {((inputs?: Tl_Clear_DatesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tl_Clear_DatesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tl_clear_dates(inputs)
	return en_tl_clear_dates(inputs)
});